<mat-form-field appearance="legacy" style="height:35px;margin-left:10px;">
    <mat-label>Type de consultation</mat-label>
    <mat-select [disabled]="contact?.id !== 0" [ngModel]="contact?.type">
        <mat-option *ngFor="let typeName of consultationTypes" (click)="selectType(typeName)" [value]="typeName">{{ typeName }}</mat-option>
    </mat-select>
</mat-form-field>